import { useSupabaseLoader } from "../../../../../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../../../../../server/supabase/hooks/types";
import type { PreviewDataRecipient } from "../../../../../server/supabase-preview-service";
import type { PreviewMomentData } from "../types";

type Data = {
  channel: PreviewMomentData["channel"];
  segment_json: NonNullable<PreviewMomentData["segment"]>["segment_json"] | null;
  target_connection_type: PreviewMomentData["target_connection_type"];
};

export function usePersonInUnsavedSegmentWithConnections({
  channel,
  segment_json,
  target_connection_type,
}: Data): UseSupabaseLoaderState<PreviewDataRecipient[]> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      if (!channel || !segment_json) return [];

      const { data, error } = await supabase.rpc("get_preview_data_segment_json_for_connection", {
        account_id_: account_id,
        segment_json,
        channel_: channel,
        connection_key_: target_connection_type ?? undefined,
      });

      if (error) throw error;

      return data;
    },
    [channel, segment_json, target_connection_type],
  );
}
